import { render, staticRenderFns } from "./MetasVendedores.vue?vue&type=template&id=4ed34e92"
import script from "./MetasVendedores.vue?vue&type=script&lang=ts"
export * from "./MetasVendedores.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports